import api from "../../helpers/api";


export const getSuppliers = (body) => api.post('supplier/search-suppliers', {...body})

export const getSupplier = (id) => api.get(`supplier/${id}`)

export const createSupplier = (formData) => api.post('supplier' , {...formData})
export const createStagingSupplier = (formData) => api.post('supplier-staging/create' , {...formData})

export const updateSupplier = (id , formData) => api.put(`supplier/${id}` , {...formData})

export const deleteSupplier = (id) => api.delete(`supplier/${id}`)

export const updateSupplierLimit = (body) => api.put(`supplier/limits/supplier-limits/`, {...body})

export const addFollower = (supplierId, userId) => api.post('supplier/add-follower')
export const removeFollower = (supplierId, userId) => api.post('supplier/rem-follower')
export const getFollowers = (supplierId) => api.post('supplier/get-followers')
export const getFollowerscount = (supplierId) => api.post('supplier/get-followers-count/')

export const addEditorsReview = (supplierId,formData) => api.post('supplier/editor-rating/' , {supplierId, ...formData})